import React, {useContext, useRef} from "react"
import {useSubscription, useMutation} from "@apollo/client"
import providerScanLog from "graphql/Storage/Provider/subscription/providerScanLog"
import providerScan from "graphql/Storage/Provider/mutation/providerScan"
import {alertContext} from "context/Alert/alert"

import "./style.scss"
import {BackofficePage, BackofficePanel} from "components/backoffice/Layout/BackofficePage"


type ProviderScanProps = {

}


export const ProviderScan = (props: ProviderScanProps) => {
  const {setError, setMessage} = useContext(alertContext)
  // const [loading, updateLoading] = useState(false)

  const loggerRer = useRef(null)

  useSubscription(providerScanLog, {
    onSubscriptionData: (response) => {
      // @ts-ignore
      const {log} = response.subscriptionData.data?.providerScan
      // console.log({status})
      // updateLoading(!!(status === "RUNNING"))
      appendLog(log)
    }
  })

  const appendLog = (log: string) => {
    const div = document.createElement('div')
    div.textContent = log;
    loggerRer.current && loggerRer.current.prepend(div)
  }

  const [mutate, {loading}] = useMutation(providerScan)

  const startScan = () => {
    mutate()
      .then(() => setMessage("Scan terminé"))
      .catch(() => setError("Le scan n'a pas pu être lancé"))
  }

  return <BackofficePage
    className="provider-scan-container"
    eyebrow="Infrastructure"
    title="Scanner les providers"
    description="Analysez les espaces connectés et suivez les opérations en temps réel."
    icon="fa-satellite-dish"
    actions={<button className="bo-primary-action" type="button" disabled={loading} onClick={startScan}>{loading ? <span className="icon-loading"></span> : <span className="fas fa-play"></span>}{loading ? "Scan en cours…" : "Lancer le scan"}</button>}
  >
    <BackofficePanel title="Journal d'exécution" description="Les événements les plus récents apparaissent en premier." icon="fa-terminal">
      <div className="logger" ref={loggerRer}>
        <div className="logger-placeholder"><span className="fas fa-terminal"></span>Prêt à lancer une analyse.</div>
      </div>
    </BackofficePanel>
  </BackofficePage>
}
